import { createI18n } from "vue-i18n";
import enMessages from "./locales/en.json";
import idMessages from "./locales/id.json";

let i18n; // global i18n

export async function setupI18n() {
  // Check for URL parameter first, then localStorage
  const urlParams = new URLSearchParams(window.location.search);
  const urlLocale = urlParams.get("locale");

  // Priority: URL parameter > localStorage > default
  const locale = urlLocale || localStorage.getItem("locale") || "id";

  // Always ensure localStorage is in sync with current locale
  if (locale !== localStorage.getItem("locale")) {
    localStorage.setItem("locale", locale);
  }

  // Log selalu, termasuk di production untuk membantu debug
  console.log(
    `i18n: Setting up with locale: ${locale} (source: ${
      urlLocale
        ? "URL"
        : localStorage.getItem("locale")
        ? "localStorage"
        : "default"
    })`
  );

  // Tambahkan metadata ke window untuk memudahkan diagnostik
  window.__i18n_setup_info = {
    setupTime: new Date().toISOString(),
    initialLocale: locale,
    source: urlLocale
      ? "URL"
      : localStorage.getItem("locale")
      ? "localStorage"
      : "default",
  };

  try {
    // With unplugin-vue-i18n, we can import JSON files directly
    // The messages are already imported at the top of the file
    const en = enMessages;
    const id = idMessages;

    console.log("i18n: Locales loaded from import, creating i18n instance");

    i18n = createI18n({
      legacy: true, // Ubah ke true agar kompatibel dengan Vue 2 style API untuk penggunaan di production
      locale,
      globalInjection: true, // Ensure i18n is globally injected into all components
      fallbackLocale: "id",
      messages: { en, id },
      warnHtmlInMessage: "off",
      escapeParameters: true,
      sync: true, // Ensure locale changes sync across components
      // Options to handle missing translations
      missingWarn: process.env.NODE_ENV !== "production", // Only show warnings in development
      fallbackWarn: process.env.NODE_ENV !== "production",
      // Return key for missing translations but only log in development
      missing: (locale, key) => {
        if (process.env.NODE_ENV !== "production") {
          console.warn(`Missing translation: ${key} for locale: ${locale}`);
        }
        return key; // Return the key for our fallback logic
      },
    });

    return i18n;
  } catch (error) {
    console.error("i18n: Error setting up i18n:", error);

    // Provide fallback with empty translations to prevent crashes
    i18n = createI18n({
      legacy: true, // Ubah ke true agar konsisten
      locale: "id",
      fallbackLocale: "id",
      messages: {
        en: {},
        id: {},
      },
      missingWarn: false,
      fallbackWarn: false,
    });

    return i18n;
  }
}

export function getI18n() {
  return i18n;
}

// Always expose i18n for diagnostics and set up event listeners
document.addEventListener("DOMContentLoaded", function () {
  // Listen for direct check events
  window.addEventListener("i18n:check", function () {
    if (i18n) {
      window.i18n = i18n;

      // Broadcast event when checked
      const event = new CustomEvent("i18n:ready", { detail: { i18n } });
      window.dispatchEvent(event);
      console.log("i18n diagnostics: Broadcast i18n:ready event on check");
    } else {
      console.log("i18n diagnostics: i18n not available during check");
    }
  });

  // Initial broadcast after a delay
  setTimeout(function () {
    if (i18n) {
      // Always make i18n available globally
      window.i18n = i18n;

      // Broadcast event when ready
      const event = new CustomEvent("i18n:ready", { detail: { i18n } });
      window.dispatchEvent(event);
      console.log("i18n diagnostics: Broadcast initial i18n:ready event");
    } else {
      console.log("i18n diagnostics: i18n not available for initial broadcast");
    }
  }, 500);
});
